import api from "@/services/api";

export interface RequestPagBankSmsPayload {
  bank_branch: string;
  account_number: string;
  franchise_id?: string;
  associate_id?: string;
}

export interface RequestPagBankSmsResponse {
  phone_number: string;
  retry_after_seconds: number;
}

class RequestPagBankSms {
  execute = async (payload: RequestPagBankSmsPayload) => {
    const response = await api().post(
      "/franchises/pagbank-connect/sms/request",
      payload
    );
    return response.data as RequestPagBankSmsResponse;
  };
}

export { RequestPagBankSms };
